(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ag-pack-selector"] && !Shopify.designMode) return;
  try {
    (function(){
    function init(root){
      if (root.dataset.agPackReady) return;
      root.dataset.agPackReady = '1';
      var form = document.getElementById(root.getAttribute('data-ag-pack-fisa')) || root.closest('form');
      if (!form) return;
      var qty = form.elements.namedItem('quantity');
      if (qty && !qty.tagName && qty.length) qty = qty[0];
      if (!qty) { qty = document.createElement('input'); qty.type = 'hidden'; qty.name = 'quantity'; qty.value = '1'; form.appendChild(qty); }
      var opts = Array.prototype.slice.call(root.querySelectorAll('[role="radio"]'));
      if (!opts.length) return;
      function checked(){ return root.querySelector('[role="radio"][aria-checked="true"]') || opts[0]; }
      function write(btn){
        var val = btn.getAttribute('data-qty');
        if (qty.value === val) return;
        qty.value = val;
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var mainBtn = form.querySelector('button[name="add"]');
      var mainText = mainBtn ? mainBtn.querySelector(':scope > span') : null;
      var sticky = root.closest('quick-add-modal') ? null : document.querySelector('#StickyATC [data-ag-atc-label]');
      function label(btn){
        var t = btn.getAttribute('data-atc-label');
        if (!t) return;
        if (mainText && !mainBtn.disabled) mainText.textContent = t;
        if (sticky) sticky.textContent = t;
      }
      function select(btn, focus){
        opts.forEach(function(b){ var on = b === btn; b.setAttribute('aria-checked', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1; });
        write(btn);
        label(btn);
        if (focus) btn.focus();
      }
      opts.forEach(function(btn, i){
        btn.addEventListener('click', function(){ select(btn, false); });
        btn.addEventListener('keydown', function(e){
          var n = opts.length, j = -1;
          switch (e.key) {
            case 'ArrowRight': case 'ArrowDown': j = (i + 1) % n; break;
            case 'ArrowLeft': case 'ArrowUp': j = (i - 1 + n) % n; break;
            case 'Home': j = 0; break;
            case 'End': j = n - 1; break;
            default: return;
          }
          e.preventDefault();
          select(opts[j], true);
        });
      });
      select(checked(), false);
      window.addEventListener('pageshow', function(){ write(checked()); label(checked()); });
    }
    function run(){ document.querySelectorAll('[data-ag-pack-fisa]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
  })();
  } catch(e) { console.error(e); }
})();

})();
